// @generated by tools/docgen — do not edit.
// Source: docs/examples/reactive_model.md

import React from 'react';
import { ReactiveModelDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function ReactiveModelPage() {
  return (
    <ExampleLayout title="Reactive model" demo={<ReactiveModelDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          Demonstrates that model changes made outside the channel context — such as in a background thread or a separate process — are pushed reactively to connected clients. A modify_project action spawns a thread that sleeps for a configurable delay, then fetches the Project from the database and saves a new name. The frontend receives the updated Task (with its nested Project) automatically, without any manual refresh.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-reactive-model-backend">
        <ExampleSectionHeading id="examples-reactive-model-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="reactive_model/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-reactive-model-models">
        <ExampleSectionHeading id="examples-reactive-model-models">
          Models
        </ExampleSectionHeading>
        <SourceFile path="reactive_model/models.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-reactive-model-serializers">
        <ExampleSectionHeading id="examples-reactive-model-serializers">
          Serializers
        </ExampleSectionHeading>
        <SourceFile path="reactive_model/serializers.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-reactive-model-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-reactive-model-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="reactive_model/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default ReactiveModelPage;
